import React from 'react';
import Icon from '../icon/icon.js';
import { liveChat } from '../../organisms/my_orders_order_cell/img/live_chat.js';
import { videoCall } from '../../organisms/my_orders_order_cell/img/video_call.js';
import { voiceCall } from '../../organisms/my_orders_order_cell/img/voice_call.js';
import classNames from '../../classnames.js';
import modules_fbf318e2 from './channels_card.module.scss.js';

const ChannelsCard = ({ type, liveModes = [], loading }) => {
    const getChannelsCardIconContainerClassName = () => classNames(modules_fbf318e2[`channels-card-${type}-icon-container`], { [modules_fbf318e2.skeleton]: loading, [modules_fbf318e2[`skeleton-${type}`]]: loading });
    const getLiveModeIcon = (modeType, modeState, index, icon) => (React.createElement("div", { className: getChannelsCardIconContainerClassName(), key: `channels-card-${type}-${modeType}-${modeState}-icon${index}` },
        React.createElement(Icon, { className: modules_fbf318e2[`channels-card-${type}-${modeType}-${modeState}-icon`], dataTestId: "mbw-channels-card-icon" }, icon)));
    const renderLiveModeIcon = (modeType, modeState, index) => {
        let orderIcon = null;
        switch (modeType) {
            case "live-chat":
                orderIcon = getLiveModeIcon(modeType, modeState, index, liveChat);
                break;
            case "video-call":
                orderIcon = getLiveModeIcon(modeType, modeState, index, videoCall);
                break;
            case "voice-call":
                orderIcon = getLiveModeIcon(modeType, modeState, index, voiceCall);
                break;
            default:
                orderIcon = null;
        }
        return orderIcon;
    };
    const getCorrectModeType = (mode) => {
        let modeType = null;
        switch (mode) {
            case "chat":
                modeType = "live-chat";
                break;
            case "video":
                modeType = "video-call";
                break;
            case "voice":
                modeType = "voice-call";
                break;
            default:
                modeType = null;
        }
        return modeType;
    };
    const renderLiveModesIcons = () => (liveModes.map((liveMode, index) => {
        const { mode, modeState } = liveMode;
        const correctModeType = getCorrectModeType(mode);
        return renderLiveModeIcon(correctModeType, modeState, index);
    }));
    const renderChannelsCard = () => (React.createElement("div", { className: modules_fbf318e2["channels-card-container"] }, renderLiveModesIcons()));
    return renderChannelsCard();
};

export { ChannelsCard as default };
//# sourceMappingURL=channels_card.js.map
